// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { fetchWrapper } from 'helpers/api'

// gets ACM data for a given segment end. This has better performance than
// fetching the path's data then boiling it down to the specific data.
export const fetchSegmentEndACM = s => fetchWrapper(`/segment-ends/${s}/acm`)

export const fetchHiLoDetails = (segmentEndId, query) => (
  fetchWrapper(`/segment-ends/${segmentEndId}/hi-lo-details${query}`)
)
